import Live from './Live';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getLiveStation } from 'state/Live/selectors';
import { requestSingleStation } from 'state/Live/actions';

export default connect(createStructuredSelector({ station: getLiveStation }), {
  requestStation: requestSingleStation,
})(Live);
